<mat-form-field class="margin-top">
    <mat-label>Select Template</mat-label>
    <mat-select [(value)]="moi.settings.content.template">
      <mat-option value="default">Default</mat-option>
      <mat-option value="dialog">Dialog</mat-option>
    </mat-select>
  </mat-form-field>